module.exports = __webpack_public_path__ + "static/img/5.5b08671.png";


//////////////////
// WEBPACK FOOTER
// ./static/m/5.png
// module id = Yva6
// module chunks = 7